import { render, staticRenderFns } from "./mine30.vue?vue&type=template&id=24666775&scoped=true"
import script from "./mine30.vue?vue&type=script&lang=js"
export * from "./mine30.vue?vue&type=script&lang=js"
import style0 from "./mine30.vue?vue&type=style&index=0&id=24666775&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24666775",
  null
  
)

export default component.exports